import React from "react"
import { SnackbarProvider } from "notistack"
import ReactDOM from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import { RecoilRoot } from "recoil"
import { ThemeProvider } from "@material-ui/core"

import App from "./App"
// import reportWebVitals from "./reportWebVitals"
import theme from "./theme"

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3} hideIconVariant>
          <Router>
            <App />
          </Router>
        </SnackbarProvider>
      </ThemeProvider>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log)
